import { ReactComponent as LocationIcon } from "../assets/icons/navbar/Location-new.svg";
import genIcons from "./genIcons";

const Location  = { Outline: genIcons(LocationIcon, { htmlColor: "transparent" }) };

export default Location;
